<main role="main" class="flex h-screen p-4 overflow-x-hidden public-page">
  <div class="m-auto mb-0 w-full max-w-[100%] md:max-w-[500px] flex flex-col">
    <div class="flex w-full items-center gap-2 mb-2 sm:mb-4">
      <app-back-button [url]="'/login'" />
      <h1
        class="truncate pr-9 text-3xl max-w-full whitespace-nowrap overflow-hidden lg:text-5xl lg:leading-[120%]"
        id="verifyEmailHeading"
      >
        {{ isLoading ? 'E-mail verifiëren...' : isSuccess ? 'E-mail geverifieerd' : 'Verificatie mislukt' }}
      </h1>
    </div>

    @if (isLoading) {
      <app-card class="block w-full mt-6 mb-9">
        <div class="flex items-center gap-4">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-500"></div>
          <p>Even geduld terwijl we uw e-mailadres verifiëren.</p>
        </div>
      </app-card>
    } @else if (isSuccess) {
      <app-card class="block w-full mt-6 mb-9">
        <div class="flex items-center gap-3 mb-4">
          <span class="!w-[22px] !h-[22px] rounded-full bg-success flex items-center justify-center">
            <mat-icon class="text-sm text-white" aria-label="Succesvol">check</mat-icon>
          </span>
          <span class="font-semibold">Verificatie succesvol!</span>
        </div>
        <p role="alert">Uw e-mailadres is succesvol geverifieerd. U kunt nu inloggen met uw account.</p>
      </app-card>
      <div class="flex justify-end mb-4">
        <button mat-flat-button color="accent" class="w-full button-large" (click)="goToLogin()">Naar inloggen</button>
      </div>
    } @else {
      <app-card class="block w-full mt-6 mb-9">
        @if (errorMessage) {
          <p class="text-red-500 text-center mb-4" role="alert">
            {{ errorMessage }}
          </p>
        }
      </app-card>
      <div class="flex justify-end mb-4 gap-2">
        <button mat-flat-button color="accent" class="w-full button-large" (click)="goToLogin()">Naar inloggen</button>
      </div>
    }
    <div class="mt-2 sm:mt-4">
      <app-logo-images></app-logo-images>
    </div>
  </div>
</main>
